import { Link } from "react-router-dom";
import Button from "../../../../components/flat/ui/Button";
import { ButtonText, Div, Subtitle, Title } from "./AuthPassword.styles";

interface AuthPasswordSuccessViewProps {
  title: string;
  subtitle: string;
  buttonLabel: string;
  buttonTo: string;
}

export default function AuthPasswordSuccessView({
  title,
  subtitle,
  buttonLabel,
  buttonTo,
}: AuthPasswordSuccessViewProps) {
  return (
    <>
      <Div>
        <Title>{title}</Title>
        <Subtitle>{subtitle}</Subtitle>
      </Div>
      <Link to={buttonTo} style={{ width: "100%", textDecoration: "none" }}>
        <Button
          type="button"
          width="100%"
          padding="10px 40px"
          borderRadius="5px"
          hoverBackgroundColor="#007656"
        >
          <ButtonText>{buttonLabel}</ButtonText>
        </Button>
      </Link>
    </>
  );
}
